var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$t("auditor.step.success.title"))+" ")]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.$t("auditor.step.success.text"))+" ")]),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","to":{
        name: 'auditAuditPeriod',
        params: { id: _vm.fund.auditPeriod.id },
      }}},[_vm._v(" "+_vm._s(_vm.$t("auditor.step.success.cta"))+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }